import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { Boundaries } from "@planzone/core";

const initialState: State = [];

function handleRequest(
  state: State,
  projectId: Boundaries["retrieveProjectLogs"]["request"],
): State {
  return [
    ...state,
    { request: setRequestStateToPending(), projectId, logs: [] },
  ];
}

function handleSuccess(
  state: State,
  { projectId, logs }: Boundaries["retrieveProjectLogs"]["success"],
): State {
  return state.map((res) =>
    res.projectId === projectId
      ? {
          ...res,
          request: setRequestStateToSuccess(),
          logs,
        }
      : res,
  );
}

function handleFailure(
  state: State,
  projectId: Boundaries["retrieveProjectLogs"]["failure"],
): State {
  return state.map((res) =>
    res.projectId === projectId
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveProjectLogsRequested]: handleRequest,
    [events.retrieveProjectLogsSucceeded]: handleSuccess,
    [events.retrieveProjectLogsFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
